import { FC } from 'react'

// eslint-disable-next-line import/no-extraneous-dependencies
import { GiftTracker1, SimpleShipping1 } from 'baby-design/icons'
import { registryGiftTrackerPath, settingsYourOrdersPath } from 'lib/urls'

import NavigationCard from '../NavigationCard'

import css from './ShipmentsNavigationCards.styles.scss'

const GiftTrackerBanner: React.FC = () => (
  <NavigationCard
    bodyCopy="Track gifts purchased from other retailers."
    buttonHref={registryGiftTrackerPath}
    graphicIcon={
      <GiftTracker1 className={css.ShipmentsNavigationCards__GiftTrackerIcon} />
    }
    headline="Gift tracker"
    testid="shipment-navigation-card-gift-tracker"
  />
)

const OrdersBanner: React.FC = () => (
  <NavigationCard
    bodyCopy="Manage all your orders from the Babylist Shop."
    buttonHref={settingsYourOrdersPath}
    graphicIcon={
      <SimpleShipping1 className={css.ShipmentsNavigationCards__OrdersIcon} />
    }
    headline="Orders"
    testid="shipment-navigation-card-orders"
  />
)

const ShipmentsNavigationCards: FC = () => (
  <div
    className={css.ShipmentsNavigationCards}
    data-testid="shipment-navigation-cards"
  >
    <GiftTrackerBanner />
    <OrdersBanner />
  </div>
)

export default ShipmentsNavigationCards
